import { render, staticRenderFns } from "./GiroBI.vue?vue&type=template&id=0900df25"
import script from "./GiroBI.vue?vue&type=script&lang=js"
export * from "./GiroBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports